module.exports = __webpack_public_path__ + "static/media/9.84f34b3f.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/9.wav
// module id = 93
// module chunks = 0